  <div class="mat-divider">
    <div>
      <a mat-button [ngClass]="sucheDisabled ? 'mini-button-disabled' : 'mini-button'"
         disabled="{{sucheDisabled}}" id="sucheButton"
         (click)="sucheMaklerpakete()">Paket suchen</a>
    </div>

    <div>
      <br>
      <span class="label-text">Bitte suchen Sie ein Maklerpaket anhand der Vermitllernummer! </span>
      <input class="inputvermittlernr" type="text"  style="width:110px" maxlength="9"
             [ngModel]="vermittlernummer" (ngModelChange)="validiereVermittlernummer($event)" />
    </div>
  </div>
